const { forEach } = require('lodash');

class FooterController {
    constructor(settings, breakpoints, $anchorScroll, moveFocus) {
        this.breakpoints = breakpoints;
        this.$anchorScroll = $anchorScroll;
        this.moveFocus = moveFocus;

        this.footerColumns = {
            customerService: this.formatLinks(settings.footer.customerServiceLinks),
            service: this.formatLinks(settings.footer.generalServiceLinks),
            tools: this.formatLinks(settings.footer.toolsLinks),
            aboutUs: this.formatLinks(settings.footer.aboutUsLinks),
        };
    }

    formatLinks(footerLinkRaw) {
        const footerLinks = [];
        forEach(footerLinkRaw, (value) => {
            if (value.length === 1) {
                footerLinks.push({
                    heading: value[0],
                    children: [],
                });
            } else if (value.length === 2 && footerLinks.length) {
                footerLinks[footerLinks.length - 1].children.push({
                    heading: value[0],
                    link: value[1],
                });
            }
        });
        return footerLinks;
    }

    isPanelSelected(panel) {
        return this.selectedPanel === panel.heading;
    }

    togglePanel(panel) {
        if (panel.children.length) {
            this.selectedPanel = (this.selectedPanel !== panel.heading)
                ? panel.heading
                : null;
        }
    }

    expandPanel(panel) {
        this.selectedPanel = panel.heading;
    }

    centerPanelFocus() {
        this.$anchorScroll();
        this.moveFocus('#body-container');
    }
}

const footerControllerComponentDefinition = {
    controller: ['Settings', 'BreakpointsService', '$anchorScroll', 'MoveFocus', FooterController],
    template: require('./footer.component.html').trim(),
};

module.exports = {
    FooterController,
    footerControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/footer/footer.component.js